import Immutable from 'seamless-immutable';
import _ from 'lodash';

import { enums } from 'console-kit';

import { assetRefService } from '../../common/Services';

import RefData from '../../ref-data';

/**
 * AccountTemplate
 * @typedef {Object} AccountTemplate
 */

/**
 * Create an AccountTemplate from provided data
 */
function create(data = {}) {
  const result = _.clone(data);
  return Immutable(result, { prototype: model });
}

function deserialize(accountTemplate) {
  const result = _.pick(accountTemplate, _keys);

  result.typeRef = RefData.Model.hydrate(accountTemplate.typeRef);
  result.subtypeRef = RefData.Model.hydrate(accountTemplate.subtypeRef);

  delete result.description; // we need to remove this so it doesn't appear in the card layout
  return create(result);
}

function serialize(accountTemplate) {
  const result = accountTemplate.asMutable({ deep: true });
  return _.pick(result, _keys);
}

/** The AccountTemplate prototype */
const model = {
  get header() {
    return this.name;
  },
  get image() {
    if (!!this.icon) return assetRefService.pathFromAssetRef(this.icon);
  },
  get fallbackIcon() {
    // we don't have icons that map to all campaign typeRefs so let's take care of the ones we don't have
    const _typeRefCode = _.get(this, ['typeRef', 'code'], '');

    switch (_typeRefCode) {
      case 'sweepstake':
        return enums.icons.TROPHY;
      case 'signup':
        return enums.icons.FORM;
      case 'goal':
        return enums.icons.TARGET2;
      case 'reveal':
        return enums.icons.CALENDAR;
      case 'social':
        return enums.icons.QUOTE;
      default:
        return this.typeRef.code || undefined;
    }
  },
};

/**
 * An array of keys on the AccountTemplate object that should be shared between the API requests and responses
 */
const _keys = ['id', 'name', 'icon', 'summary', 'typeRef', 'subtypeRef'];

export default {
  create,
  deserialize,
  serialize,
};
